export enum ESidebarItemType {
  Add = 'add',
  Avatar = 'avatar',
  Button = 'button',
  Heading = 'heading',
  HelpLaunch = 'help-launch'
}
